import { render, staticRenderFns } from "./Tariff.vue?vue&type=template&id=48900e4a&scoped=true"
import script from "./Tariff.vue?vue&type=script&lang=js"
export * from "./Tariff.vue?vue&type=script&lang=js"
import style0 from "./Tariff.vue?vue&type=style&index=0&id=48900e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48900e4a",
  null
  
)

export default component.exports